import { Icon } from "../icons";
import { UI_NAMESPACE, useT } from "../i18n";
import { Popover, PopoverContent, PopoverTrigger } from "../components/popover/popover";

export function InfoTooltip({ content }: { content?: string | null }) {
  const { t } = useT(UI_NAMESPACE);

  if (!content) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger
        type="button"
        aria-label={t("common.more-info", "More information")}
        className="ml-1 inline-flex rounded-lt-sm text-lt-muted-fg outline-none hover:text-lt-fg focus-visible:text-lt-fg focus-visible:ring-lt-ring/50 focus-visible:ring-[length:var(--lt-ring-width)]"
      >
        <Icon name="info" className="size-lt-icon-sm" />
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="max-w-xs p-3 text-sm [&_a]:underline"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Popover>
  );
}
